<template>
  <div class="container-exibicao" @click="$refs.input.focus()">
    <span class="exibicao">
      <b>{{ filtro.name }}:</b>
      <input
        ref="input"
        type="text"
        v-mask="mascara"
        :placeholder="filtro.placeholder || 'MM/AAAA'"
        :value="text"
        @input="onInput"
        @keyup.enter="aplicarFiltro"
        @blur="aplicarFiltro"
      />
      <SVGIcon iconName="icon-close" :size="8" @click.stop="excluirFiltro" />
    </span>
    <span ref="textSizer" class="text-sizer">{{ text }}</span>
  </div>
</template>
<script>
import SVGIcon from '../../../SvgIcon.vue';

export default {
  emits: ['excluirFiltro'],
  components: {
    SVGIcon
  },
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      text: '',
      mascara: '##/####'
    };
  },
  methods: {
    onInput(evento) {
      this.text = evento.target.value;
      this.ajustarLarguraInput();
    },
    aplicarFiltro() {
      if (!this.text) {
        return this.excluirFiltro();
      }
      if (!this.textoValido()) return;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.text, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.text
      });
    },
    excluirFiltro() {
      this.text = '';
      this.$store.commit('removeFiltro', this.filtro.filtro);
      this.$removeFiltroDaURL(this.filtro.filtro, this.path);
      this.$store.commit('removeFiltroAplicado', this.filtro.filtro);
      this.$emit('excluirFiltro', this.filtro.filtro, this.path);
    },
    textoValido() {
      return /^\d{2}\/\d{4}$/.test(this.text);
    },
    ajustarLarguraInput() {
      const input = this.$refs.input;
      const textSizer = this.$refs.textSizer;
      if (input && textSizer) {
        textSizer.textContent = input.value || this.filtro.placeholder || 'MM/AAAA';
        input.style.width = `${textSizer.offsetWidth + 5}px`;
      }
    }
  },
  watch: {
    '$store.state.filtroAplicados': {
      handler(novoFiltrosAplicados) {
        const aplicado = novoFiltrosAplicados[this.filtro.filtro];
        if (!aplicado) {
          this.text = '';
        }
      },
      deep: true
    }
  },
  mounted() {
    const aplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    if (aplicado) {
      this.text = aplicado;
    }
    this.$nextTick(() => this.ajustarLarguraInput());
  }
}
</script>
